<div class="size-5">
  <app-svg-icon
    [icon]="icon()"
    fill="#BCBCBC" />
</div>
